import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PixCheckoutPanel = ({ pixData, license, onClose }) => {
  const [copied, setCopied] = useState(false);
  const qrCode = pixData?.qr_code;
  const qrCodeBase64 = pixData?.qr_code_base64;
  const ticketUrl = pixData?.ticket_url;

  const handleCopy = async () => {
    if (!qrCode) return;

    try {
      await navigator.clipboard.writeText(qrCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="space-y-5">
      <div className="rounded-lg border border-primary/20 bg-primary/5 p-4 flex gap-3">
        <Icon name="QrCode" size={20} className="text-primary flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-sm font-medium text-foreground">Pague com PIX</p>
          <p className="text-xs text-muted-foreground">
            Escaneie o QR Code ou copie o código Pix para pagar {license?.license_name}.
            A licença será liberada após a confirmação do pagamento.
          </p>
        </div>
      </div>

      {qrCodeBase64 && (
        <div className="flex justify-center">
          <img
            src={`data:image/png;base64,${qrCodeBase64}`}
            alt="QR Code PIX"
            className="h-56 w-56 rounded-lg border border-border bg-white p-3"
          />
        </div>
      )}

      {qrCode && (
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">Pix Copia e Cola</p>
          <div className="rounded-lg border border-border bg-muted/20 p-3">
            <p className="text-xs font-mono break-all text-foreground">{qrCode}</p>
          </div>
          <Button fullWidth variant="outline" onClick={handleCopy}>
            {copied ? 'Código copiado' : 'Copiar código Pix'}
          </Button>
        </div>
      )}

      {ticketUrl && (
        <Button
          fullWidth
          onClick={() => window.open(ticketUrl, '_blank', 'noopener,noreferrer')}
          iconName="ExternalLink"
          iconPosition="right"
        >
          Abrir pagamento no Mercado Pago
        </Button>
      )}

      <Button variant="outline" fullWidth onClick={onClose}>
        Voltar para a loja
      </Button>
    </div>
  );
};

export default PixCheckoutPanel;
